'use strict';

var React = require('react');

let counter = 0;
function useId() {
    let [id] = React.useState(`ss-ui-react-ele-${++counter}`);
    return id;
}

module.exports = useId;
